export { FAQCategory } from './index.pc'
export { MobileFAQCategory } from './index.mobile'
